import React from "react";
import styled from "styled-components";
import { Plus } from "react-feather";
import { SPOTTER_STRINGS } from "./strings";

/** Changes-panel item pill for one value gained from a list (a source, a term, an excluded tag,
 *  a routed FR person) — same shape as `SpotterNewTag`, green like it, but a distinct label so
 *  "this whole field is new" (`SpotterNewTag`, group-level) never reads the same as "this one
 *  value was added to an otherwise-existing field" (item-level). */
const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 99px;
  white-space: nowrap;
  font-family: ui-monospace, Menlo, monospace;
  background: var(--spotterOkSoft);
  color: var(--spotterOk);
  border: 1px solid var(--spotterOkLine);
  flex-shrink: 0;
`;

const SpotterAddedTag = () => (
  <Tag>
    <Plus size={11} />
    {SPOTTER_STRINGS.addedTag}
  </Tag>
);

export default SpotterAddedTag;
